.root {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.top {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.inner {
  flex-shrink: 1;
  width: 100%;
}

.content {
  display: flex;
  width: 100%;
  margin-top: 1.5rem;
}

.transcript {
  display: flex;
  min-height: 24px;
  padding-left: 1.5rem;
  margin-bottom: 1rem;
}

.favorite {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
}

.cover {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 15%;
  min-width: 190px;
  margin-left: auto;
  margin-left: 3.5rem;
}

.share {
  margin-top: 0.5rem;
}
